module.exports = __webpack_public_path__ + "img/adjust-specifications.a29b140d.gif";